import {clientsClaim as workbox_core_clientsClaim} from '/Applications/MAMP/htdocs/restaurant-de-kade/wp-content/themes/pe-restaurant-de-kade/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Applications/MAMP/htdocs/restaurant-de-kade/wp-content/themes/pe-restaurant-de-kade/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appimg/icons.c5666ccb.svg",
    "revision": "cbdf6081cf006ad2cb815c8d0caee2ed"
  },
  {
    "url": "library/build/appmain.1afd8395.css",
    "revision": null
  },
  {
    "url": "library/build/appmain.f690423b.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.f690423b.js.LICENSE.txt",
    "revision": "03a5086eb08e176e6321b068af2817eb"
  }
], {});








